/* 馬良（字季常） */
import { SG } from '../../core/kit.ts';
import { defineHero, U } from '../define.ts';

export default defineHero({
  id: 'maliang', name: '馬良', sub: '字季常', faction: 'shu', role: '法師/輔助', weapon: 'fan',
  look: { head: 'guan', robe: true, fx: '#9fe7ff', c: { cloth: '#e6e2d6', sleeve: '#e6e2d6', armor: '#5a8a6a', fan: '#e8f2ff' } },
  skills: [
    ['魔力反噬', 'bolt', '讓敵人的魔力反噬自身：{140/195/250/305} 傷害，再加目標智力 ×{2/2.5/3/3.5}。', { x: { k: 'nuke', dmg: [140, 195, 250, 305], intMul: [2, 2.5, 3, 3.5], fx: 'thunder' }, aim: U(480), cd: 22, mp: [100, 125, 150, 175], el: 'shadow' }],
    ['退魔擊', 'bolt', '燒掉目標最多 {90/180/240/330} 點氣，並造成等量傷害。', { x: { k: 'nuke', burn: [90, 180, 240, 330] }, aim: U(360), cd: 15, mp: [100, 110, 120, 130] }],
    ['淨化', 'bolt', '移除目標身上的增益並緩速 4 秒；對召喚物造成 {100/200/300/400} 傷害。', { x: { k: 'nuke', purge: [100, 200, 300, 400], cc: { slow: { amt: 50, dur: 4 } } }, aim: U(560), cd: [15, 13, 12, 10], mp: [125, 100, 75, 50] }],
    ['代價', 'heal', '完全回復一名友軍的生命，但他的氣降為上限的 {20/10/0}%。', { x: { k: 'fullheal', mp: [20, 10, 0] }, aim: U(560), cd: 110, mp: [100, 125, 150], el: 'shadow' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    fullheal(u, a, X) {
      const t = this.xAlly(u, a.pt, this.skillRange(a.sk, a.lvl), true);
      this.heal(t, t.maxHp); if (!SG.isNeng(t)) t.mp = Math.min(t.mp, t.maxMp * X.mp / 100);
      this.fx({ k: 'heal', x: t.x, y: t.y, col: u.spec.fx });
    },
  },
});
